import { render, staticRenderFns } from "./Inscriptions-opened-comp.vue?vue&type=template&id=1d1e7c22&"
import script from "./Inscriptions-opened-comp.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-opened-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports